import * as React from 'react'

export function usePaginateRows<T>(rows: T[], page, pageSize): T[] {
  return React.useMemo(() => rows.slice((page - 1) * pageSize, page * pageSize), [rows, page, pageSize])
}
